import { CompanyTheme } from '../../api/types';
import DayjsRangePicker from '../../components/DayjsRangePicker';
import CheckboxField from '../../components/fields/CheckboxField';
import PhoneAndPrefixField from '../../components/fields/ci/PhoneField';
import CountryField from '../../components/fields/CountryField';
import DatePickerField from '../../components/fields/DatePickerField';
import DisplayField from '../../components/fields/DisplayField';
import DisplayFieldWithUTCOffset from '../../components/fields/DisplayFieldWithUTCOffset';
import FixedRangePickerField from '../../components/fields/FixedRangePickerField';
import GenderField from '../../components/fields/GenderField';
import IdentityNumberField from '../../components/fields/IdentityNumberField';
import InputNumberField from '../../components/fields/InputNumberField';
import MaritalStatusField from '../../components/fields/MaritalStatusField';
import MultipleDraggerField from '../../components/fields/MultipleDraggerField';
import NationalityField from '../../components/fields/NationalityField';
import RaceField from '../../components/fields/RaceField';
import RangePickerField from '../../components/fields/RangePickerField';
import RegionField from '../../components/fields/RegionField';
import ResidentialStatusField from '../../components/fields/ResidentialStatusField';
import SelectField from '../../components/fields/SelectField';
import SwitchField from '../../components/fields/SwitchField';
import TimePickerField from '../../components/fields/TimePickerField';
import TranslatedInputField from '../../components/fields/TranslatedInputField';
import VehicleCarousel from '../../components/Images';
import PaginatedTableWithContext from '../../components/PaginatedTableWithContext';
import TimePicker from '../../components/TimePickerField';
import type { ThemeComponents } from '../context';
import Anchor from '../default/Anchor';
import Calculator from '../default/Calculator';
import CardWithHeader from '../default/CardWithHeader';
import ConfiguratorDepositDisplay from '../default/Configurator/DepositDisplay';
import ConfiguratorMessageButton from '../default/Configurator/MessageButton';
import ConfiguratorSubHeader from '../default/Configurator/SubHeader';
import ConsentModal from '../default/ConsentModal';
import Dropdown from '../default/Dropdown';
import ErrorMessageBox from '../default/ErrorMessageBox';
import InputField from '../default/Fields/InputField';
import PasswordField from '../default/Fields/PasswordField';
import InfoMessageBox from '../default/InfoMessageBox';
import JourneySteps from '../default/JourneySteps';
import ListItem from '../default/ListItem';
import LoadingSpinner from '../default/LoadingSpinner';
import MobilityWebpageLayout from '../default/Mobility/WebPageLayout';
import Modal from '../default/Modal';
import notification from '../default/notification';
import PageWithHeader from '../default/PageWithHeader';
import Popconfirm from '../default/Popconfirm';
import Search from '../default/Search';
import Select from '../default/Select';
import StandardLayout from '../default/Standard/Layout';
import Steps from '../default/Steps';
import Tabs from '../default/Tabs';
import Tooltip from '../default/Tooltip';
import WarningMessageBox from '../default/WarningMessageBox';
import makeThemeComponents from '../makeThemeComponents';
import Carousel from '../porsche/Carousel';
import ArrowDownIcon from './ArrowDownIcon';
import BackButton from './BackButton';
import Button from './Button';
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';
import CloseButton from './CloseButton';
import ComparisonButton from './ComparisonButton';
import ConfiguratorDropdown from './Configurator/Dropdown';
import ConfiguratorLayout from './Configurator/Layout';
import LegalText from './ConsentsAndDeclarations/LegalText';
import Input from './Input';
import Radio from './Radio';
import Title from './Title';
import VWGlobalStyles from './VWGlobalStyles';

const VolkswagenTheme: ThemeComponents = {
    theme: CompanyTheme.Volkswagen,
    gutter: {
        testDriveModal: [14, 14],
    },
    Input,
    ConfiguratorSubHeader,
    ConfiguratorMessageButton,
    ConfiguratorDepositDisplay,
    PageWithHeader,
    ConfiguratorDropdown,
    Dropdown,
    Select,
    StandardLayout,
    ConfiguratorLayout,
    Button,
    Title,
    MobilityWebpageLayout,
    BackButton,
    CloseButton,
    ComparisonButton,
    FinderLayout: ConfiguratorLayout,
    Checkbox,
    CheckboxGroup,
    RangePicker: DayjsRangePicker,
    TimePicker,
    FormFields: {
        RangePickerField,
        FixedRangePickerField,
        SelectField,
        DatePickerField,
        InputField,
        InputNumberField,
        IdentityNumberField,
        NationalityField,
        PhoneAndPrefixField,
        RegionField,
        CountryField,
        MultipleDraggerField,
        TimePickerField,
        RaceField,
        GenderField,
        ResidentialStatusField,
        MaritalStatusField,
        CheckboxField,
        SwitchField,
        TranslatedInputField,
        DisplayField,
        PasswordField,
        DisplayFieldWithUTCOffset,
    },
    LoadingSpinner,
    Modal,
    ConsentModal,
    notification,
    Radio,
    RadioGroup: Radio.Group,
    CardWithHeader,
    Steps,
    Search,
    ErrorMessageBox,
    WarningMessageBox,
    JourneySteps,
    PaginatedTableWithContext,
    Popconfirm,
    Carousel,
    InfoMessageBox,
    Tooltip,
    Calculator,
    ListItem,
    Tabs,
    Anchor,
    LegalText,
    ArrowDownIcon,
    VehicleCarousel,
};

export default makeThemeComponents('VolkswagenThemeProvider', VolkswagenTheme, VWGlobalStyles);
